import { DataValidationError } from "constants/DataValidationError";
import { IsNotEmpty } from "class-validator";

export default class DeleteDiscountReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly discountId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.discountId = arg.discountId;
  }
}
